import styled from 'styled-components'
import { COLOURS } from 'resources'
import RoundedButton from 'components/RoundedButton'

export const Container = styled.div`
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${COLOURS.neutralBlack};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 24px;
`

export const ChevronRight = styled.i.attrs({
  className: 'killi-icon-arrow-forward-ios',
})`
  width: 20px;
  height: 20px;
  display: flex;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  ${({ $open }) => $open && 'transform: rotate(90deg);'}
  &:hover {
    cursor: pointer;
  }
`

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLOURS.neutralBlack};
  margin-top: 10px;
`

export const EmailRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  margin-top: 10px;
  padding-bottom: 5px;
  font-size: 14px;
  color: ${COLOURS.neutralBlack};
  position: relative;

  border-bottom: 1px solid ${COLOURS.neutralGrey3};
  :last-of-type {
    padding-bottom: 0;
    border-bottom: none;
  }
`

export const MoreIcon = styled.i.attrs({
  className: 'killi-icon-dots-horizontal',
})`
  width: 20px;
  height: 20px;
  display: flex;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transform: rotate(90deg);
  &:hover {
    cursor: pointer;
  }
`

export const More = styled.div`
  z-index: 1;
  position: absolute;
  top: 25px;
  right: -70px;
  border-radius: 4px;
  border: 1px solid ${COLOURS.neutralGrey3};
  background-color: ${COLOURS.neutralWhite};
  min-width: 120px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${COLOURS.neutralBlack};
  &:hover {
    background-color: ${COLOURS.neutralGrey2};
    cursor: pointer;
  }
  border-radius: 4px;
  margin: 5px;
  padding: 0 2px;
`

export const OptionIcon = styled.i`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 3px;
`

export const OptionImg = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 3px;
`

export const Spacer = styled.div`
  display: flex;
  flex: 1;
`

export const EmailText = styled.div`
  display: flex;
  font-family: 'EBGaramond', sans-serif;
  font-size: 14px;
  word-break: break-word;
  overflow-wrap: break-word;
`

export const PrimaryPill = styled.div`
  display: flex;
  color: ${COLOURS.secondaryPurple1};
  border-radius: 20px;
  padding: 2px 0;
  border: 1px solid ${COLOURS.secondaryPurple2};
  font-size: 12px;
  line-height: 12px;
  align-items: center;
  justify-content: center;
  margin: 6px 0 0 8px;
  min-width: 50px;
  align-self: flex-start;
`

export const ButtonsContainer = styled.div`
  margin-top: 20px;
`

export const AddEmailButton = styled(RoundedButton).attrs({
  variant: 'transparentPurple1',
})`
  min-height: unset;
  width: 100%;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid ${COLOURS.secondaryPurple1};

  &:hover {
    border-color: ${COLOURS.secondaryPurple1};
  }
`
